import React, { useCallback, useState } from "react";
import { Box, Grid } from "atoms";

import { LoginForm } from "molecules/LoginForm/LoginForm";
import { useAuth } from "contexts/Auth";
import { useNavigate } from "react-router-dom";
import { QUERY_PARAMS_ITEMS } from "utils/constants";

const Login = () => {
  const {
    actions: { login },
  } = useAuth();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = useCallback(
    async ({ email, password }) => {
      setLoading(true);
      login(email, password)
        .then((success) => {
          success &&
            navigate({
              pathname: "/otp",
              search: `?${new URLSearchParams({
                [QUERY_PARAMS_ITEMS.workflow]: [QUERY_PARAMS_ITEMS.isLogin],
              })}`,
            });
        })
        .catch((e) => {
          setError(e?.message);
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [login, navigate]
  );

  return (
    <Box h="100vh">
      <Grid aI="center" h="100vh" px="12rem">
        <LoginForm
          onSubmit={onSubmit}
          loading={loading}
          error={error}
          resetError={() => setError("")}
        />
      </Grid>
    </Box>
  );
};

export default Login;
